module.exports = __webpack_public_path__ + "media/images/btn_active_stallions-d370b9139c4850221a8a2e270b36026c.gif";